@import '../../../global/global.pcss';

:host {
  display: block;
  height: inherit;
  width: inherit;
  & > slot {
    height: inherit;
  }
}
